module.exports = __webpack_public_path__ + "img/amsbannner2.7e212234.png";